import { useSelector } from 'react-redux'
import { messagesSelectors, selectMessages } from 'store/messages'
import { settingsSelectors } from 'store/settings'
import { ChatResponseModeEnum } from 'types/chat'
import { UserMessage } from 'components/messages/UserMessage'
import { TicketInfoCard } from 'components/ui/TicketInfoCard'
import { OperatorMessage } from 'components/messages/OperatorMessage'
import { BotMessage } from 'components/messages/BotMessage'
import { useCallback, useMemo } from 'react'
import _ from 'lodash'
import { ChatMessage, MessageTypeEnum } from 'types/chat-message'
import { getMessageSide, MessageSide } from 'utils/chats'
import { SystemMessage } from 'components/messages/SystemMessage'
import { MessageScrollerItem } from '@/components/ui/message-scroller'

export const ChatMessages = () => {
  const messages = useSelector(selectMessages)
  const currentChatTicket = useSelector(messagesSelectors.currentChatTicket)
  const currentUserId = useSelector(settingsSelectors.userId)

  const lastMessageInBotMode = useMemo(() => {
    if (!currentChatTicket) {
      return undefined
    }
    const message = _.findLast(messages, (message) => message.chatResponseMode === ChatResponseModeEnum?.BOT)
    return message?._id
  }, [messages, currentChatTicket])

  const renderMessage = useCallback(
    (message: ChatMessage, i: number) => {
      if (message.type === MessageTypeEnum.SYSTEM) {
        return [
          <MessageScrollerItem messageId={message._id} key={message._id}>
            <SystemMessage messageItem={message} />
          </MessageScrollerItem>,
        ]
      }

      const side = getMessageSide(message, currentUserId)
      const isLastMessageInBotMode = lastMessageInBotMode === message._id

      let content
      if (side === MessageSide.Own) {
        content = <UserMessage messageItem={message} />
      } else if (side === MessageSide.Bot) {
        content = <BotMessage messageItem={message} index={i} />
      } else {
        content = <OperatorMessage messageItem={message} index={i} />
      }

      const result = [
        <MessageScrollerItem messageId={message._id} key={message._id} scrollAnchor={side === MessageSide.Own}>
          {content}
        </MessageScrollerItem>,
      ]
      if (isLastMessageInBotMode) {
        result.push(
          <MessageScrollerItem messageId="ticket-info" key="ticket-info">
            <TicketInfoCard />
          </MessageScrollerItem>,
        )
      }

      return result
    },
    [lastMessageInBotMode, currentUserId],
  )

  return <>{messages.map(renderMessage)}</>
}
